import LinkIcon from "@mui/icons-material/Link";
import { Stack, Typography, alpha, useTheme } from "@mui/material";

import { CommonDialog } from "@/components/common/CommonDialog";
import { PrimaryButton, SecondaryButton } from "@/components/common";

interface WooLoginPromptDialogProps {
  open: boolean;
  storeName: string;
  onClose: () => void;
  onLogin: () => void;
}

/** Primeira abertura da loja — vinculação OpenID Fluxmed no WordPress. */
export function WooLoginPromptDialog({
  open,
  storeName,
  onClose,
  onLogin,
}: WooLoginPromptDialogProps) {
  const theme = useTheme();

  const footer = (
    <Stack
      direction={{ xs: "column-reverse", sm: "row" }}
      spacing={1.5}
      justifyContent="flex-end"
      width="100%"
    >
      <SecondaryButton width="fit-content" height="44px" onClick={onClose}>
        Cancelar
      </SecondaryButton>
      <PrimaryButton
        width={{ xs: "100%", sm: "fit-content" }}
        height="44px"
        onClick={onLogin}
        startIcon={<LinkIcon />}
      >
        Vincular conta
      </PrimaryButton>
    </Stack>
  );

  return (
    <CommonDialog
      isOpen={open}
      handleClose={onClose}
      maxWidth="sm"
      sheetTitle="Vincular conta"
      sheetSubtitle=""
      footer={footer}
    >
      <Stack spacing={1.5} sx={{ px: { xs: 0, md: 0.5 }, pt: 0.5 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            px: 1.25,
            py: 0.875,
            borderRadius: 1.5,
            bgcolor: alpha(theme.palette.primary800.main, 0.06),
          }}
        >
          Para solicitar em <strong>{storeName}</strong>, vincule sua conta Fluxmed.
          Uma janela segura será aberta.
        </Typography>
      </Stack>
    </CommonDialog>
  );
}
